import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface TopologySlice {
  tab: string;
  deviceTableData: any;
  staticIPCount: number;
  deviceRecord: any;
  alarmTableVisible: boolean;
  deviceStateVisible: boolean;
  IoTVisible: boolean;
  mapVisible: boolean;
  restore: any;
  // editable: boolean;
  editCityVisible: boolean;
  editDescriptionVisible: boolean;
  isFilter: boolean;
  isConfigFetching: boolean;
  ///setting
  showSettingItems: {
    LAN: boolean;
    WAN: boolean;
    LTE: boolean;
    WiFi: boolean;
    Alarm: boolean;
    Period: boolean;
  };
  deviceIdToGetConfig: any;
  fileNameToGetConfig: any;
  formData: any;
  nodeInf: any;
  deviceNum: string[];
  showDualSim: boolean;
  NodeList: any;
  selectedModel: string;
  importSource: "Device" | "NewConfig" | "FileRepository";
  filterCondition: {
    model: string;
    groups: any;
    locations: any;
  };
  hasGPS: boolean;
  saveConfigVisible: boolean;
  resultList: {
    failureDevices: any;
    rebootDevices: any;
    errorDevices: any;
    successDevices: any;
    rebootfailDevices: any;
    rebootSuccessDevices: any;
    total: number;
  };
  resultModalVisible: boolean;
  IPv4Disabled: boolean;
  IPv4MaskDisabled: boolean;
  IPv6DnsServer2Disabled: boolean;
  LTELimitDisabled: boolean;
  LTE2LimitDisabled: boolean;
  //Allfilter
  filterDeviceOptions: any;
  deviceIDList: any;
}

export const initialState: TopologySlice = {
  tab: "1",
  deviceTableData: [],
  staticIPCount: 0,
  deviceRecord: undefined,
  alarmTableVisible: false,
  deviceStateVisible: false,
  IoTVisible: false,
  mapVisible: false,
  restore: [],
  // editable: false,
  editCityVisible: false,
  editDescriptionVisible: false,
  isFilter: false,
  isConfigFetching: false,
  ///setting
  showSettingItems: {
    LAN: false,
    WAN: false,
    LTE: false,
    WiFi: false,
    Alarm: false,
    Period: false,
  },
  deviceIdToGetConfig: undefined,
  fileNameToGetConfig: undefined,
  formData: [],
  nodeInf: [],
  deviceNum: [],
  showDualSim: true,
  NodeList: [],
  selectedModel: "M330",
  importSource: "NewConfig",
  filterCondition: {
    model: "",
    groups: [],
    locations: [],
  },
  hasGPS: true,
  saveConfigVisible: false,
  resultList: {
    failureDevices: [],
    rebootDevices: [],
    errorDevices: [],
    successDevices: [],
    rebootfailDevices: [],
    rebootSuccessDevices: [],
    total: 0,
  },
  resultModalVisible: false,
  IPv4Disabled: false,
  IPv4MaskDisabled: false,
  IPv6DnsServer2Disabled: false,
  LTELimitDisabled: false,
  LTE2LimitDisabled: false,
  //Allfilter
  filterDeviceOptions: [],
  deviceIDList: [],
};

const topologySlice = createSlice({
  name: "topology",
  initialState,
  reducers: {
    setIsFilter: (state, action: PayloadAction<boolean>) => {
      state.isFilter = action.payload;
    },
    setTab: (state, action: PayloadAction<string>) => {
      state.tab = action.payload;
    },
    setDeviceTableData: (state, action: PayloadAction<any>) => {
      state.deviceTableData = action.payload;
    },
    setStaticIPCount: (state, action: PayloadAction<number>) => {
      state.staticIPCount = action.payload;
    },
    setDeviceRecord: (state, action: PayloadAction<any>) => {
      state.deviceRecord = action.payload;
    },
    setAlarmTableVisible: (state, action: PayloadAction<boolean>) => {
      state.alarmTableVisible = action.payload;
    },
    setDeviceStateVisible: (state, action: PayloadAction<boolean>) => {
      state.deviceStateVisible = action.payload;
    },
    setIoTVisible: (state, action: PayloadAction<boolean>) => {
      state.IoTVisible = action.payload;
    },
    setMapVisible: (state, action: PayloadAction<boolean>) => {
      state.mapVisible = action.payload;
    },
    setRestore: (state, action: PayloadAction<any>) => {
      state.restore = action.payload;
    },
    // setEditable: (state, action: PayloadAction<boolean>) => {
    //   state.editable = action.payload;
    // },
    setEditCityVisible: (state, action: PayloadAction<boolean>) => {
      state.editCityVisible = action.payload;
    },
    setEditDescriptionVisible: (state, action: PayloadAction<boolean>) => {
      state.editDescriptionVisible = action.payload;
    },
    setShowSettingItems: (state, action: PayloadAction<any>) => {
      state.showSettingItems = action.payload;
    },
    setDeviceIdToGetConfig: (state, action: PayloadAction<any>) => {
      state.deviceIdToGetConfig = action.payload;
    },
    setFileNameToGetConfig: (state, action: PayloadAction<any>) => {
      state.fileNameToGetConfig = action.payload;
    },
    setNodeList: (state, action: PayloadAction<string[]>) => {
      state.NodeList = action.payload;
    },
    setFormData: (state, action: PayloadAction<any>) => {
      state.formData = action.payload;
    },
    setShowDualSim: (state, action: PayloadAction<boolean>) => {
      state.showDualSim = action.payload;
    },
    setDeviceNum: (state, action: PayloadAction<string[]>) => {
      state.deviceNum = action.payload;
    },
    setSelectedModel: (state, action: PayloadAction<string>) => {
      state.selectedModel = action.payload;
    },
    setImportSource: (state, action: PayloadAction<TopologySlice["importSource"]>) => {
      state.importSource = action.payload;
    },
    setFilterCondition: (state, action: PayloadAction<any>) => {
      state.filterCondition = action.payload;
    },
    setHasGPS: (state, action: PayloadAction<boolean>) => {
      state.hasGPS = action.payload;
    },
    setSaveConfigVisible: (state, action: PayloadAction<boolean>) => {
      state.saveConfigVisible = action.payload;
    },
    setResultList: (state, action: PayloadAction<any>) => {
      state.resultList = action.payload;
    },
    setResultModalVisible: (state, action: PayloadAction<boolean>) => {
      state.resultModalVisible = action.payload;
    },
    setIPv4Disabled: (state, action: PayloadAction<boolean>) => {
      state.IPv4Disabled = action.payload;
    },
    setIPv4MaskDisabled: (state, action: PayloadAction<boolean>) => {
      state.IPv4MaskDisabled = action.payload;
    },

    setIPv6DnsServer2Disabled: (state, action: PayloadAction<boolean>) => {
      state.IPv6DnsServer2Disabled = action.payload;
    },
    setLTELimitDisabled: (state, action: PayloadAction<boolean>) => {
      state.LTELimitDisabled = action.payload;
    },
    setLTE2LimitDisabled: (state, action: PayloadAction<boolean>) => {
      state.LTE2LimitDisabled = action.payload;
    },
    setIsConfigFetching: (state, action: PayloadAction<boolean>) => {
      state.isConfigFetching = action.payload;
    },
  },
});

export const {
  setIsFilter,
  setTab,
  setDeviceTableData,
  setStaticIPCount,
  setDeviceRecord,
  setAlarmTableVisible,
  setDeviceStateVisible,
  setIoTVisible,
  setMapVisible,
  setRestore,
  // setEditable,
  setEditCityVisible,
  setEditDescriptionVisible,
  setShowSettingItems,
  setDeviceIdToGetConfig,
  setFileNameToGetConfig,
  setNodeList,
  setFormData,
  setShowDualSim,
  setDeviceNum,
  setSelectedModel,
  setImportSource,
  setFilterCondition,
  setHasGPS,
  setSaveConfigVisible,
  setResultList,
  setResultModalVisible,
  setIPv4Disabled,
  setIPv4MaskDisabled,
  setIPv6DnsServer2Disabled,
  setLTELimitDisabled,
  setLTE2LimitDisabled,
  setIsConfigFetching,
} = topologySlice.actions;

export default topologySlice;
